// @ts-nocheck
interface FooterProps {
  setActiveView: (view: string) => void;
}

export function Footer({ setActiveView }: FooterProps) {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-gradient-to-br from-orange-500 to-amber-600 p-2 rounded-lg">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-lg font-bold">MONERO RIG</span>
            </div>
            <p className="text-sm text-slate-500">Professional Monero mining infrastructure for everyone.</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><button onClick={() => setActiveView("home")} className="hover:text-white transition-colors" data-testid="footer-plans-link">Mining Plans</button></li>
              <li><button onClick={() => setActiveView("home")} className="hover:text-white transition-colors">Pricing</button></li>
              <li><button onClick={() => setActiveView("dashboard")} className="hover:text-white transition-colors">Dashboard</button></li>
              <li><a href="https://github.com/monero-project/monero" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Mobile App</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><button onClick={() => setActiveView("about")} className="hover:text-white transition-colors" data-testid="footer-about-link">About Us</button></li>
              <li><button onClick={() => setActiveView("faq")} className="hover:text-white transition-colors" data-testid="footer-faq-link">FAQ</button></li>
              <li><button onClick={() => setActiveView("contact")} className="hover:text-white transition-colors">Careers</button></li>
              <li><button onClick={() => setActiveView("contact")} className="hover:text-white transition-colors" data-testid="footer-contact-link">Contact</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-500">
              <li><button onClick={() => setActiveView("privacy")} className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</button></li>
              <li><button onClick={() => setActiveView("terms")} className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</button></li>
              <li><button onClick={() => setActiveView("privacy")} className="hover:text-white transition-colors">Cookie Policy</button></li>
              <li><button onClick={() => setActiveView("terms")} className="hover:text-white transition-colors">AML Policy</button></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">© 2026 MONERO RIG. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a
              data-testid="footer-twitter"
              href="https://twitter.com/intent/follow?screen_name=monero"
              target="_blank"
              rel="noreferrer"
              title="Follow on X"
              className="text-slate-500 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.25 2.046 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
            </a>
            <a
              data-testid="footer-github"
              href="https://github.com/monero-project/monero"
              target="_blank"
              rel="noreferrer"
              title="Monero on GitHub"
              className="text-slate-500 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
            </a>
            <a
              data-testid="footer-telegram"
              href="https://t.me/monero"
              target="_blank"
              rel="noreferrer"
              title="Join on Telegram"
              className="text-slate-500 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}